import { LimitReachedChip } from './LimitReachedChip';

export const LimitReachedTooltipHeader = ({ chipLabel }: { chipLabel: string }) => (
  <LimitReachedChip label={chipLabel} />
);
